import ReactGA from "react-ga4";
import store from "store";
import { inDevelopMode } from "utils/env";

export const initializeGA = () => {
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
    debug: inDevelopMode,
  });
};

export function fireEvent(eventParams) {
  const user = store.getState()?.app?.user?.info?.user;
  const { interacted_from, event_name, content_type, ...rest } = eventParams;

  const gaData = {
    content_type,
    ...(!!interacted_from && { interacted_from }),
    platform_source: "web",
    user_email: user?.email || "",
    user_name: user?.full_name || "",
    user_designation: user?.designation?.name || "",
    ...rest,
    ...(process.env.REACT_APP_NODE_ENV === "development" && {
      debug_mode: true,
    }), // 👈 only in dev
  };
  
  ReactGA.gtag("event", event_name, gaData);
  // console.log("GA Sent: ", gaData);
}